import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuActionLink = _resolveComponent("MenuActionLink");
    const _component_MenuLevel3 = _resolveComponent("MenuLevel3");
    return (_ctx.isAction(_ctx.menuData))
        ? (_openBlock(), _createBlock(_component_MenuActionLink, {
            key: 0,
            isTopLevel: false,
            menuData: _ctx.menuData
        }, null, 8, ["menuData"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItems(_ctx.menuData), (item) => {
                return (_openBlock(), _createElementBlock("span", {
                    key: item.text
                }, [
                    (_ctx.isAction(item))
                        ? (_openBlock(), _createBlock(_component_MenuActionLink, {
                            key: 0,
                            isTopLevel: false,
                            menuData: item
                        }, null, 8, ["menuData"]))
                        : (_openBlock(), _createBlock(_component_MenuLevel3, {
                            key: 1,
                            menuData: item
                        }, null, 8, ["menuData"]))
                ]));
            }), 128))
        ]));
}
